<ndt-add-phone-view
   [callState]="callState$ | async"
   [phone]="phone"
   [phoneTypes]="phoneTypes"
   [accountId]="accountId"
   [form]="form"
   [isSystemUser]="isSystemUser$ | async"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
></ndt-add-phone-view>
